import { Box, HStack, VStack, Text, CircularProgress } from "@chakra-ui/react";

import useCoinInfo from "hooks/useCoinInfo";
import toCoinLocale from "util/toCoinLocale";
import formatter from "util/formatter";

export default function CoinPerformance(props) {
  const { coin, price, isFetching } = props;

  const { label, icon } = useCoinInfo(coin);

  return (
    <Box {...props} pos="relative">
      <Text color="#14142B" fontSize="18px" fontWeight="600" mb="10px">
        Coin Performance
      </Text>
      <Box borderRadius="10px" bg="#14142B" p="20px 16px" pos="relative">
        {isFetching && (
          <Box pos="absolute" top="0px" right="8px">
            <CircularProgress isIndeterminate color="green.400" size="14px" />
          </Box>
        )}
        <HStack>
          <VStack>
            <Box boxSize="40px" as={icon} />
            <Text fontSize="10px" fontWeight="400" color="#ffffff8f">
              {toCoinLocale(coin)}
            </Text>
          </VStack>

          <Box>
            <Text fontSize="14px" color="#FCFCFC">
              {label} Price
            </Text>
            <HStack>
              <Text color="white" fontSize="24px" fontWeight="600">
                {formatter("usd").format(price)}
              </Text>
              {/* <Text ml="20px !important" color="green.300" fontSize="xs">
                0.83%
              </Text> */}
            </HStack>
          </Box>
        </HStack>
      </Box>
    </Box>
  );
}
